import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http } from '@angular/http';
import { constant } from 'app/app.constants';
import { ParentService } from 'app/pages/A2-utils/ParentClass/ParentService';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { IRegion } from 'app/core/interfaces/region.interface';
import { IDepot } from 'app/core/interfaces/depot.interface';

@Injectable()
export class DepotService extends ParentService {

  private selectedRegionIdsSource = new BehaviorSubject<number[]>([]);
  selectedRegionIds$ = this.selectedRegionIdsSource.asObservable();

  constructor(
    private http: Http,
    private router: Router
  ) {
    super()
   }

  setSelectedRegionIds(regionIds: number[]): void {
    this.selectedRegionIdsSource.next(regionIds || []);
  }

   getAllRegions(): Observable<IRegion[]> {
    return this.http.get(constant.URL_REGION, this.getHeader())
    .map(res => res.json())
    .catch((error: any) => Observable.throw(error.json()));
   }

   getRegionsByProvider(providerid: number, showInactive?: boolean): Observable<IRegion[]> {
    return this.http.get(
      `${constant.URL_REGION}/ByProvider/${providerid}?showInactive=${showInactive ? showInactive : false}`,
      this.getHeader()
    )
    .map(res => res.json())
    .catch((error: any) => Observable.throw(error.json()));
   }

   /**
    * this get all depots
    */
   getAllDepots() {
     return this.http.get(constant.URL_DEPOT, this.getHeader())
     .map(res => res.json())
     .catch(error => this.validate401Error(error, this.router));
   }

  /**
   * this get all depots by provider
   * @param providerid provider id
   */
  getDepootsByProvider(providerid: any, showInactive?: boolean): Observable<IDepot[]> {
    return this.http
      .get(
        `${constant.URL_DEPOT_BY_PROVIDER}${providerid}?showInactive=${
          showInactive ? showInactive : false
        }`,
        this.getHeader()
      )
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

   /**
    * this get depot data by id
    */
   getDepotById(id) {
    return this.http.get(constant.URL_DEPOT + `/${id}`, this.getHeader())
    .map(res => res.json())
    .catch(error => this.validate401Error(error, this.router));
   }

   /**
    * this delete depot
    * @param id id depot to delete
    */
   deleteDepot(id) {
     return this.http.delete(constant.URL_DEPOT + `/${id}`, this.headerPost())
     .map(res => res.json())
     .catch(error => this.validate401Error(error, this.router));
   }

   /**
    * this save depot on db
    * @param data data to save
    */
   saveDepot(data) {
     const body = JSON.stringify(data);
     return this.http.post(constant.URL_DEPOT, body, this.headerPost())
     .map(res => res.json())
     .catch(error => this.validate401Error(error, this.router));
   }

   /**
    * this edit depot on db
    * @param data data to edit
    */
   editDepot(data) {
    const body = JSON.stringify(data);
    return this.http.put(constant.URL_DEPOT, body, this.headerPost())
    .map(res => res.json())
    .catch(error => this.validate401Error(error, this.router));
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/providers/components/depot/depot.service.ts